import React from 'react';
import classes from './legalDocumentBody.module.css';

/**
 * Полный текст юридического документа (из PDF), без iframe.
 */
const LegalDocumentBody = ({ text }) => {
  return <div className={classes.text}>{text}</div>;
};

export default LegalDocumentBody;
